import React from 'react';
import { connect } from 'react-redux';
import { _Button } from '../common/styled-buttons';
import { svgAsPngUri } from 'save-svg-as-png';
import { downloadDataUri } from '../../core/firebase/actions';
import FileSaver from 'file-saver';

class Download extends React.Component {

  downloadJson() {
    const blob = new Blob([JSON.stringify(this.props.json)], { type: "application/json" });
    FileSaver.saveAs(blob, 'chart.json');
  }

  downloadPng() {
    const highResSettings = {
      scale: this.props.scale || 1.0,
      backgroundColor: '#fff',
      encoderType: 'image/jpeg',
      encoderOptions: 0.95,
    }

    svgAsPngUri(document.querySelector(".fanchart svg svg"), highResSettings, (uri => {
      downloadDataUri(uri);
    }))
  }

  downloadSvg() {
    const svg = document.querySelector(".fanchart svg svg");
    const blob = new Blob([svg.outerHTML], {type:"image/svg+xml;charset=utf-8"});
    FileSaver.saveAs(blob, 'chart.svg');
  }

  handleClick = () => {
    if(this.props.type === 'json') {
      this.downloadJson();
    } else if(this.props.type === 'svg') {
      this.downloadSvg();
    } else {
      this.downloadPng();
    }
  }

  render() {
    return (
      <_Button unstyled onClick={this.handleClick}>
        {this.props.text || "Download"}
      </_Button>
    )
  }
}

const mapStateToProps = state => ({
  json: {
    chart: state.chart,
    generations: state.generations,
    cells: {
      cells: state.cells.cells.slice(0, Math.pow(2, state.chart.generations)),
    }
  }
})

export default connect(mapStateToProps)(Download);


// WEBPACK FOOTER //
// ./src/components/export/download.js